import { Box } from "@mui/material";

export default function NotFound() {
	return (
		<Box
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
			}}
			mt={10}
		>
			<h1>404 - nicht gefunden</h1>
			<p>Diese Seite existiert nicht oder wurde verschoben.</p>
		</Box>
	);
}
